<template>
  <v-layout class="inner-pages" column>

    <program-levels-header><span class="font-weight-regular">Program Levels</span></program-levels-header>

    <v-layout>
      <v-flex xs12 text-xs-center style="margin-top:-40px; height:0;z-index: 1 ">
        <div class="user-avatar elevation-10"
          :style="{
            backgroundImage: 'url(' + $store.getters['user/avatar'] + ')',
            height: '80px',
            width: '80px'
          }"></div>
      </v-flex>
    </v-layout>

    <v-flex class="sfh-login-form background-image">

          <v-content class="fill-height center-pb-10">
            <v-layout row wrap align-center justify-center fill-height>
              <v-flex xs12 text-xs-center px-4>

                <v-container grid-list-xl class="pt-0">
                  <v-layout>
                    <v-flex xs2></v-flex>
                    <v-flex xs4 pl-1>

                      <v-btn id="badgeBtnId" large :class="getBadgeButtonClass()" dark color="primary"
                        @click="displayBadgeDialog" block>

                        <strong>Badge</strong>
                      </v-btn>
                    </v-flex>
                    <v-flex xs4 pr-1>
                      <v-btn id="examBtnId" class="exam-btn white--text" @click="getExam" :class="getExamButtonClass()"
                        large color="#edc30c" block><strong>Exam</strong></v-btn>
                    </v-flex>
                    <v-flex xs2></v-flex>
                  </v-layout>
                </v-container>

                <v-container px-0 pt-0 grid-list-xs>
                  <div class="justify-space-between flex">
                    <div>

                      <!----------------------->
                      <v-layout row wrap align-center class="level-row" justify-left :key="index"
                                v-for="(level,index) in levels">
                        <popover :pointer="false" event="hover" :width="200" name="foo">
                          This level is marked for re-quiz based on your exam scores. You must use the level quiz again to
                          re-enable the exam.
                        </popover>

                        <v-flex class="card-list">
                          <v-layout>
                            <v-flex v-if="Object.keys(level.memberLevel).length !== 0" xs2 :color="getLearningNeedColor(level)">

                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-btn class="elevation-1 progress-icon progress-tour" fab small style="border-radius:0"
                                         @click="showLevelDetails(level)" v-on="on"
                                         :class="(currentStep === 3 || currentStep === 4) && index === levels.length - 1? 'current-step':''"
                                         :color="getLearningNeedColor(level)">
                                    <span class="notranslate" v-if="getProgressIcon(level)"><font-awesome-icon :icon="getProgressIcon(level)"
                                                                                 color="white" style="font-size: 22px;" /></span>
                                    <img v-else src="static/images/re_quiz.png" height="30" v-popover:foo.top />
                                  </v-btn>
                                </template>
                                <span>My Progress</span>
                              </v-tooltip>
                            </v-flex>

                            <v-flex xs2 mt-3 mb-3 v-else>&nbsp;</v-flex>

                            <v-flex :ref="'formContainer' + level.id" xs8 class="text-xs-left" style="padding-top:5px;"
                                    :style="examStatus === IN_EXAM ? 'cursor:default;':''" :class="levelClassObj(index, level)">

                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-flex class="px-2 pt-1 flex-border hide-overflow learn-bar" @click="learnLevel(level)"
                                          v-on="on" :class="getLearningNeedColor(level)" lighten-4>
                                    <span class="font-weight-medium" v-text="level.id+'. '+level.name"></span>
                                    <v-progress-linear class="elevation-20 mt-1 mb-2" :color="getLearningNeedColor(level)"
                                                       background-color="white" height="3" :value="level.memberLevel.skillPercentage">
                                    </v-progress-linear>
                                  </v-flex>
                                </template>
                                <span>Tap to learn level</span>
                              </v-tooltip>

                            </v-flex>
                            <v-flex v-if="Object.keys(level.memberLevel).length !== 0"
                                    :class="examStatus === IN_EXAM ? 'no-pointer':''" @click="quizLevel(level)" xs2 md2>

                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-btn fab small v-on="on" class="elevation-1 quiz-icon quiz-tour"
                                         :class="(currentStep === 1 || currentStep === 2) && index === levels.length - 1? 'current-step':''"
                                         style="border-radius:0" :color="getLearningNeedColor(level)"
                                         v-if="getQuizIcon(level).type === 'image'">

                                    <img v-if="level.memberLevel.learningNeedColor === 3" height="30"
                                         src="static/images/re_quiz.png">
                                    <img v-else height="30" :src="getQuizIcon(level).src">

                                  </v-btn>
                                  <v-btn v-else fab v-on="on" class="elevation-1 quiz-icon quiz-tour" small
                                         style="border-radius:0"
                                         :class="(currentStep === 1 || currentStep === 2)&& index === levels.length - 1? 'current-step':''"
                                         :color="getLearningNeedColor(level)">

                                    <img v-if="level.memberLevel.learningNeedColor === 3" height="30"
                                         src="static/images/re_quiz.png">
                                    <span v-else class="notranslate"><font-awesome-icon :icon="getQuizIcon(level).src"
                                                                                 style="font-size: 22px;color:#fff;" /></span>

                                  </v-btn>
                                </template>
                                <span>Tap to start quiz</span>
                              </v-tooltip>

                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <!----------------------->
                      <v-layout row wrap align-center justify-left>

                        <v-flex xs2 color="primary" class="caption font-weight-bold" style="line-height: 1;">
                          <small>My<br>Progress</small>
                        </v-flex>
                        <v-flex xs8 class="text-xs-center caption font-weight-bold"><small>Learn</small></v-flex>
                        <v-flex xs2 class="caption font-weight-bold"><small>Quiz</small></v-flex>
                      </v-layout>
                    </div>

                    <div style="display: flex;width: 100%;justify-content: center;" v-if="getEnabledLevelsCount() > 0 && getEnabledLevelsCount() < 4 && bestCoupon !== '' && bestCoupon.prompt !== ''">
                      <v-alert
                        mode="dark"
                        color="warning"
                        :value="true"
                        :style="{color: '#333', width: $store.getters.getAppWidth+'px', position: 'fixed', 'bottom': 0, 'display': 'flex', padding: 0}"
                      >

                        <div style="display: flex; justify-content: space-between" class="py-2">

                          <v-flex style="text-align: start;padding-left:5px;">
                            <div class="py-1 font-weight-bold px-2"><span>{{ bestCoupon.prompt }}</span></div>
                          </v-flex>
                          <v-flex class="d-flex align-center" style="text-align: end;" @click="openBuyNow"><v-btn color="info">Buy now</v-btn></v-flex>
                        </div>
                      </v-alert>
                    </div>
                  </div>

                </v-container>
              </v-flex>
            </v-layout>
            <template>
              <div class="text-xs-center">
                <v-dialog v-model="progressDialog" :width="$store.getters.getAppWidth - 10">
                  <v-card>
                    <v-toolbar dark color="primary">
                      <v-toolbar-title>{{currentLevel.name}}</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-toolbar-items>
                        <v-btn icon dark @click="progressDialog = false">
                          <span class="notranslate"><v-icon>close</v-icon></span>
                        </v-btn>
                      </v-toolbar-items>
                    </v-toolbar>

                    <v-card-text class="pt-0 pb-0">
                      <v-layout row>
                        <v-flex xs12>

                          <v-list class="pt-0">
                            <template>
                              <v-subheader class="blue--text text--darken-1">
                                <blockquote class="blockquote pa-0">
                                  Your skill level is <strong>{{currentMemberLevel.skillPercentage}}</strong></blockquote>
                              </v-subheader>


                              <v-list-tile avatar>
                                <v-list-tile-avatar>
                                  <v-btn fab small dark style="border-radius:0"
                                    :color="currentMemberLevel.skillPercentage === 0 ? getLearningNeedColor(currentLevel) : 'secondary lighten-2'">
                                    <span class="notranslate"><font-awesome-icon :icon="['fas', 'book-reader']" style="font-size: 22px;" /></span>
                                  </v-btn>
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                  <v-list-tile-title>Not Started</v-list-tile-title>
                                  <v-list-tile-sub-title>Use the quiz</v-list-tile-sub-title>
                                </v-list-tile-content>
                              </v-list-tile>

                              <v-list-tile avatar>
                                <v-list-tile-avatar>
                                  <v-btn fab small dark style="border-radius:0" :color="currentMemberLevel.skillPercentage <= 70 &&
                                       currentMemberLevel.skillPercentage > 0 ?
                                        getLearningNeedColor(currentLevel) : 'secondary lighten-2'">
                                    <span class="notranslate"><font-awesome-icon :icon="['fas', 'check']" style="font-size: 22px;" /></span>
                                  </v-btn>
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                  <v-list-tile-title>Beginner</v-list-tile-title>
                                  <v-list-tile-sub-title>Use the quiz again!</v-list-tile-sub-title>
                                </v-list-tile-content>
                              </v-list-tile>

                              <v-list-tile avatar>
                                <v-list-tile-avatar>
                                  <v-btn fab small dark style="border-radius:0" :color="currentMemberLevel.skillPercentage > 70 &&
                                       currentMemberLevel.skillPercentage <= 90 ?
                                        getLearningNeedColor(currentLevel) : 'secondary lighten-2'">
                                    <span class="notranslate"><font-awesome-icon :icon="['far', 'thumbs-up']" style="font-size: 22px;" /></span>
                                  </v-btn>
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                  <v-list-tile-title>Advanced</v-list-tile-title>
                                  <v-list-tile-sub-title>You are test ready at this level</v-list-tile-sub-title>
                                </v-list-tile-content>
                              </v-list-tile>

                              <v-list-tile avatar>
                                <v-list-tile-avatar>
                                  <v-btn fab small dark style="border-radius:0"
                                    :color="currentMemberLevel.skillPercentage > 90 ? getLearningNeedColor(currentLevel) : 'secondary lighten-2'">
                                    <span class="notranslate"><font-awesome-icon :icon="['fas', 'user-graduate']" style="font-size: 22px;" /></span>
                                  </v-btn>
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                  <v-list-tile-title>Expert</v-list-tile-title>
                                  <v-list-tile-sub-title>Top command on all subjects</v-list-tile-sub-title>
                                </v-list-tile-content>
                              </v-list-tile>

                              <v-divider></v-divider>

                              <v-subheader class="blue--text text--darken-1 font-weight-medium">
                                <blockquote class="blockquote pl-0">Last quiz time was <strong>{{latestQuizTime()}}</strong>
                                </blockquote>
                              </v-subheader>

                              <v-list-tile avatar>
                                <v-list-tile-avatar>
                                  <v-btn fab small style="border-radius:0" :color="currentMemberLevel.latestQuizTime === 0 ?
                                       getLearningNeedColor(currentLevel)
                                        : 'secondary lighten-2'">
                                    <span class="notranslate"><font-awesome-icon :icon="['fas', 'question']" style="font-size: 22px;" /></span>
                                  </v-btn>
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                  <v-list-tile-title>Use the quiz</v-list-tile-title>
                                </v-list-tile-content>
                              </v-list-tile>

                              <v-list-tile avatar>
                                <v-list-tile-avatar>
                                  <v-btn fab small style="border-radius:0" :color="currentMemberLevel.latestQuizTime > 6 * 30 ?
                                       getLearningNeedColor(currentLevel) : 'secondary lighten-2'">
                                    <img src="static/images/snail.png" height="30" alt="Snail">
                                  </v-btn>
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                  <v-list-tile-title>Slow like a snail</v-list-tile-title>
                                </v-list-tile-content>
                              </v-list-tile>

                              <v-list-tile avatar>
                                <v-list-tile-avatar>
                                  <v-btn fab small style="border-radius:0" :color="currentMemberLevel.latestQuizTime > 3 * 30 && currentMemberLevel.latestQuizTime <= 6 * 30 ?
                                       getLearningNeedColor(currentLevel) : 'secondary lighten-2'">
                                    <img src="static/images/bunny.png" height="30" alt="Bunny">

                                  </v-btn>
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                  <v-list-tile-title>Quick like a bunny!</v-list-tile-title>
                                  <v-list-tile-sub-title>Less then 3 minutes</v-list-tile-sub-title>
                                </v-list-tile-content>
                              </v-list-tile>

                              <v-list-tile avatar>
                                <v-list-tile-avatar>
                                  <v-btn fab small style="border-radius:0" :color="currentMemberLevel.latestQuizTime <= 3 * 30 && currentMemberLevel.latestQuizTime > 0 ?
                                       getLearningNeedColor(currentLevel) : 'secondary lighten-2'">
                                    <img src="static/images/cat.png" height="30" alt="Fast as cat">
                                  </v-btn>
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                  <v-list-tile-title>Fast as a cat</v-list-tile-title>
                                  <v-list-tile-sub-title>Less then 90 seconds</v-list-tile-sub-title>
                                </v-list-tile-content>
                              </v-list-tile>
                            </template>

                          </v-list>
                        </v-flex>
                      </v-layout>

                    </v-card-text>
                  </v-card>
                </v-dialog>

              </div>
            </template>
          </v-content>

          <v-dialog v-model="loadingDialog" :hide-overlay="hideOverlay" persistent width="300">
            <v-card color="primary" dark>
              <v-card-text>
                {{loadingCourseDialogMsg}}
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>

          <!----  Exam Dialog -->
          <v-dialog v-model="examDialog" :width="$store.getters.getAppWidth - 10">
            <v-card v-if="badgeConfirm === false">
              <v-card-title class="title primary pa-3 font-weight-light white--text" primary-title>
                Confirm your new badge
                <v-spacer></v-spacer>
                <span class="notranslate"><v-icon dark @click="examDialog = false">clear</v-icon></span>
              </v-card-title>

              <v-card-text>
                <v-layout row wrap align-center justify-center>
                  <v-flex xs12 class="text-xs-center pt-1">
                    <v-btn-toggle v-model="badgeImage">
                      <v-btn text color="primary" value="front" small>
                        Front
                      </v-btn>
                      <v-btn text color="primary" value="back" small>
                        Back
                      </v-btn>
                    </v-btn-toggle>
                  </v-flex>

                  <v-flex pa-2 xs12 class="text-xs-center">
                    <img class="elevation-10" v-if="badgeImage === 'front' && frontImg"
                      style="height:150px;border-radius: 10px;" :src="frontImg">
                    <v-img class="pa-5" v-if="badgeImage === 'front' && frontImg === ''">
                      <v-progress-circular indeterminate color="blue lighten-2"></v-progress-circular>
                    </v-img>

                    <img class="elevation-10" v-if="badgeImage === 'back' && backImg"
                      style="height:150px;border-radius: 10px;" :src="backImg">
                  </v-flex>

                  <v-flex xs12>
                    Before taking the exam please confirm your photo and name. The credit-card-size badge will be sent
                    when you pass the exam.
                  </v-flex>

                  <v-flex pt-4 xs12>
                    <v-btn color="primary" outline block dark small @click="settingsDrawer = true">Edit photo or
                      name&hellip;</v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-btn color="pink" flat @click="examDialog = false">Close</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="green" flat @click="confirmExam"> Confirm </v-btn>
              </v-card-actions>
            </v-card>

            <v-card v-if="examQuestionsLoader === true">
              <v-card-title class="title primary pa-3 font-weight-light white--text" primary-title>
                Certificate Program Test
              </v-card-title>

              <v-card-text>
                <v-layout row wrap align-center justify-center>

                  <v-flex pa-2 xs12>
                    <v-progress-circular indeterminate color="blue lighten-2"></v-progress-circular>&nbsp;&nbsp;Preparing
                    exam&hellip;
                  </v-flex>
                </v-layout>

              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="examDialog = false"> Cancel </v-btn>
              </v-card-actions>
            </v-card>

            <v-card v-if="badgeConfirm === true && newExamDialogStep1 === true && examQuestionsLoader === false">
              <v-card-title class="title primary pa-3 font-weight-light white--text" primary-title>
                Certificate Program Test
              </v-card-title>

              <v-card-text>
                <v-layout row wrap align-center justify-center>

                  <v-flex pa-2 xs12>
                    <p>Your test has been created and is now available.</p>
                    <p>Remember that you must submit responses to all questions to complete the test.</p>
                  </v-flex>
                </v-layout>

              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="newExamDialogStep1 = false"> Start </v-btn>
              </v-card-actions>
            </v-card>

            <v-card v-if="badgeConfirm === true && newExamDialogStep1 === false">
              <v-card-title class="title primary pa-3 font-weight-light white--text" primary-title>
                Certificate Program Test
              </v-card-title>

              <v-card-text>
                <v-layout row wrap align-center justify-center>

                  <v-flex pa-2 xs12>
                    <p>Confirm below when ready to start.</p>
                    <ul>
                      <li>There are 40 questions</li>
                      <li>There is no time limit</li>
                      <li>You will be LOCKED IN to the test until you have answered all questions</li>
                      <li>Other app functions like LEARN and QUIZ are disabled during the test</li>
                    </ul>
                    <br>
                    <p>A score of <strong>70%</strong> or more earns a <strong><span v-text="appName" /> certificate</strong> and
                      <strong>eBadge</strong>.
                    </p>
                  </v-flex>
                </v-layout>

              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-btn color="pink" flat @click="examDialog = false"> Cancel </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="green" flat @click="startExam"> Continue </v-btn>

              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="inExamDialog" :width="$store.getters.getAppWidth - 10">
            <v-card v-if="examQuestionsLoader === false">
              <v-card-title class="title primary pa-3 font-weight-light white--text" primary-title>
                Certificate Program Test
              </v-card-title>

              <v-card-text>
                <v-layout row wrap align-center justify-center>

                  <v-flex pa-2 xs12>
                    <p>The exam is underway.</p>
                    <p>You completed {{$store.getters['exam/getAnsweredQuestions']}} of
                      {{$store.getters['exam/getExamQuestionsCount']}} questions.</p>
                  </v-flex>
                </v-layout>

              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="startExam"> Resume </v-btn>
              </v-card-actions>
            </v-card>

            <v-card v-if="examQuestionsLoader === true">
              <v-card-title class="title primary pa-3 font-weight-light white--text" primary-title>
                Certificate Program Test
              </v-card-title>

              <v-card-text>
                <v-layout row wrap align-center justify-center>

                  <v-flex pa-2 xs12>
                    <v-progress-circular indeterminate color="blue lighten-2"></v-progress-circular>&nbsp;&nbsp;Preparing
                    exam&hellip;
                  </v-flex>
                </v-layout>

              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="examDialog = false"> Cancel </v-btn>
              </v-card-actions>
            </v-card>

          </v-dialog>

          <!-- $15 Badge Purchase---->
          <v-dialog v-model="upgradeDialog" :width="getUpgradeLicenseDialogWidth" persistent>
            <v-card>
              <v-card-title class="title primary pa-3 font-weight-light white--text" primary-title>
                <span v-text="showCoupons === true ? 'Select Coupon' : 'Upgrade License'" />
                <v-spacer></v-spacer>
                <span class="notranslate"><v-icon dark @click="upgradeDialog = false">clear</v-icon></span>
              </v-card-title>

              <v-card-text class="pb-0">
                <div>
                  <v-layout v-if="licenseClientToken!== 0">
                    <license-payment
                      name="test14"
                      page="quick-payment"
                      :token="licenseClientToken"
                      :paypal="true" :userId="user.id" orderId="SFHTier1"
                      :memberId="group.memberId" :selectedCouponId="selectedCouponId" :amount="effectivePrice">
                    </license-payment>
                  </v-layout>
                  <v-layout v-else row wrap align-center justify-center>
                    <v-flex pa-2 xs12>Hello! Pay the license fee to complete the certificate program. You'll get all levels
                      and features, as well as unlimited exam attempts. </v-flex>
                    <v-flex pa-2 xs6 class="text-xs-center"><img style="height:100px;"
                        src="static/images/learn_and_play.png"></v-flex>
                    <v-flex pa-2 xs6 class="text-xs-center"><a target="__blank"
                        href="https://www.cogneti.com/user-license">License details&hellip;</a></v-flex>
                    <v-flex v-if="selectedCouponCode" px-2 py-0 xs12 class="green--text">
                      Coupon <span class="font-weight-bold" v-text="selectedCouponCode" /> applied successfully!!
                    </v-flex>
                    <v-flex px-2 xs12>
                      <v-btn color="success" block @click="fetchBtToken">
                        Upgrade for
                        <span
                          style="text-decoration: line-through;"
                          v-if="selectedCouponCode">&nbsp;${{price}}</span>
                        &nbsp;<span class="subheading font-weight-bold">${{printPrice(effectivePrice)}}</span>
                      </v-btn>
                    </v-flex>

                    <v-flex px-2 xs12 v-if="this.buyNow === false">
                      <v-layout>
                        <v-flex xs12>
                          <v-text-field label="Coupon" clearable @click:clear="clearCoupon()" v-model="appliedCoupon">
                            <template v-slot:append>
                              <v-btn flat class="mr-0" :disabled="selectedCouponCode !== '' && appliedCoupon !== ''"
                              :loading="couponLoading" color="info" @click="validateCoupon">Apply
                              <template v-slot:loader>
                                Applying...
                              </template>
                            </v-btn>
                            </template>

                          </v-text-field>
                        </v-flex>
                      </v-layout>

                    </v-flex>

                    <v-flex px-2 pb-4 class="text-xs-center" v-if="this.buyNow === false">
                      <button
                        class="coupon-available"
                        @click="showCoupons = true"
                        style="text-decoration: underline">Check for your discount coupons</button>
                    </v-flex>

                    <v-flex px-2 pb-4 class="text-xs-center" v-if="this.buyNow">
                      &nbsp;
                    </v-flex>
                  </v-layout>
                </div>

                <div v-if="showCoupons === true">

                  <v-card :key="index" v-for="(coupon, index) in coupons">
                    <v-card-title primary-title class="coupon green lighten-5">
                      <v-flex>
                        <v-flex class="coupon coupon-hover green lighten-4" @click="selectCoupon(coupon)">
                          <span class="font-weight-bold" v-text="coupon.code"/>
                          <span class="notranslate"><v-icon  style="float:right;">content_copy</v-icon></span>
                        </v-flex>
                        <v-layout wrap class="py-2">
                          <v-flex xs4 text-xs-left>
                            <span class="title font-weight-medium"
                              v-text="coupon.discount + '% OFF'"
                              style="font-size:15px!important;" />
                          </v-flex>
                          <v-flex xs8 text-xs-right>
                            <span class="subheading font-weight-light">Price:</span>
                            <s>${{price}}</s> <span class="title font-weight-medium"
                              v-text="'$'+printPrice(getDiscountedPrice(coupon.discount))"
                              style="font-size:17px!important;" /></v-flex>
                        </v-layout>
                      </v-flex>
                    </v-card-title>
                  </v-card>
                  <v-flex v-if="!coupons.length">
                    <p class="subheading red--text">
                      No coupons are available!
                    </p>
                  </v-flex>
                  <v-flex class="text-xs-left">
                    <v-btn flat class="pl-0 ml-0" @click="showCoupons = false">
                      <span class="notranslate"><v-icon>keyboard_backspace</v-icon></span> Back
                    </v-btn>
                  </v-flex>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- $15 Badge Purchase---->

          <v-tour name="examTour" :steps="steps" style="margin-right: 15px">
            <template slot-scope="tour">
              <transition name="fade">
                <v-step v-if="tour.currentStep === index" v-for="(step, index) of tour.steps" :key="index" :step="step"
                  :previous-step="tour.previousStep" :next-step="tour.nextStep" :stop="tour.stop" :is-first="tour.isFirst"
                  :is-last="tour.isLast" :labels="tour.labels">
                  <template>
                    <div slot="actions">
                      <button @click="disableExamPopup"
                        class="v-btn v-btn--outline  v-btn--small v-btn--depressed theme--light primary">OK</button>
                    </div>
                  </template>
                </v-step>
              </transition>
            </template>
          </v-tour>

          <div id="overlay" :class="(examStatus === NOT_READY || examStatus === IN_EXAM || examStatus === RETAKE)
        && isOverlay === true?'d-block':'d-none'"></div>

          <badge-button page="programLevels" :badgeDialog="displayBadgeDialogValue"></badge-button>

          <three-dots :loading="syncing" title="Loading" />
    </v-flex>

    <v-dialog v-model="welcomeDialog"  v-if="welcomeDialog && !loadingDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">👋 Welcome! {{ user.firstName }}</v-card-title>
        <v-card-text v-if="getUserDetails.existing_user === true">
          <p>Your profile has been updated successfully.</p>
        </v-card-text>
        <v-card-text v-else>
          <p>Your account has been created successfully with username <strong>{{ user.friendlyName }}</strong>.</p>
          <p>Please check your mailbox for more details..</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="welcomeDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-layout>


</template>

<script>
  import ProgramLevelsHeader from '../layouts/ProgramLevelsHeader'
  import Vue from 'vue'
  import VueFlip from 'vue-flip'
  import VPopover from 'vue-js-popover'
  import VueTour from 'vue-tour'
  import { constants, NOT_READY, READY, IN_EXAM, RETAKE } from '@/mixins/constants'
  import BadgeButton from './widgets/BadgeButton'
  import ThreeDots from './widgets/ThreeDots'
  import LicensePayment from './widgets/LicensePayment'
  import ScrollData from '../ScrollData'
  import Header from '../layouts/Header'
  // Import component
  import Loading from 'vue-loading-overlay'
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'
  import {mapGetters, mapMutations} from 'vuex'
  // Init plugin
  Vue.use(Loading)
  require('vue-tour/dist/vue-tour.css')
  Vue.use(VueTour)
  Vue.use(VPopover, { tooltip: true })

  function isEmpty (obj) {
    return Object.keys(obj).length === 0
  }

  function plural (value, unit) {
    if (value === 1) {
      return value + ' ' + unit
    } else if (value > 1) {
      return value + ' ' + unit + 's'
    }
  }

  export default {
    name: 'ProgramLevels',
    components: { Header, ScrollData, LicensePayment, ThreeDots, BadgeButton, ProgramLevelsHeader, 'vue-flip': VueFlip },
    mixins: [constants],
    data () {
      return {
        apiUrl: process.env.API_URL,
        appId: process.env.GAME_ID,
        appName: process.env.APP_NAME,
        fullPage: false,
        uname: '',
        couponLoading: false,
        groupName: '',
        upgradeDialog: '',
        displayBadgeDialogValue: 0,
        dbUrl: process.env.DB_URL,
        progressDialog: false,
        hideOverlay: false,
        checking: false,
        currentLevel: [],
        currentMemberLevel: [],
        examDialog: false,
        badgeImage: 'front',
        frontImg: '',
        frontBadgeImg: '',
        backImg: '',
        backBadgeImg: '',
        badgeConfirm: false,
        isOverlay: false,
        newExamDialogStep1: true,
        inExamDialog: false,
        badgeMailSend: false,
        selectedCouponCode: '',
        showCoupons: false,
        coupons: [],
        price: 0,
        effectivePrice: 0,
        selectedCouponId: null,
        appliedCoupon: '',
        bestCoupon: '',
        buyNow: false
      }
    },
    computed: {
      ...mapGetters('registration', ['getUserDetails']),
      welcomeDialog: {
        get: function () {
          return this.getUserDetails.welcome
        },
        set: function () {
          this.setUser({
            ...this.getUserDetails,
            welcome: false
          })
        }
      },
      getUpgradeLicenseDialogWidth () {
        if (this.$vuetify.breakpoint.name === 'xs') {
          return this.$store.getters.getAppWidth - 10
        } else {
          return this.$store.getters.getAppWidth - 100
        }
      },
      steps: {
        get: function () {
          let content = ''
          switch (this.examStatus) {
            case NOT_READY: content = 'Use the QUIZ on at least four levels to enable the exam.'
              break
            case IN_EXAM: content = 'The exam is underway.'
              break
            case RETAKE: content = 'Enable the exam again by taking the quiz at least once for all levels marked RED for re-training.'
              break
            default: content = ''
          }
          return [{
            target: '#examBtnId',
            content,
            params: {
              placement: 'left'
            }
          }]
        },
        set: function () {

        }
      },
      settingsDrawer: {
        get: function () {
          return this.$store.getters.getSettingsDrawer
        },
        set: function (newValue) {
          this.$store.commit('setSettingsDrawer', newValue)
        }
      },
      syncing: {
        get: function () {
          const isCourseAlreadyLoaded = this.$store.getters['course/getCourseLevelLoadedAfterLogin']
          return this.$store.getters['getLoadingCourseDialog'] && isCourseAlreadyLoaded
        },
        set: function (value) {
        }
      },
      loadingDialog: {
        get: function () {
          const isCourseAlreadyLoaded = this.$store.getters['course/getCourseLevelLoadedAfterLogin']
          return this.$store.getters['getLoadingCourseDialog'] && !isCourseAlreadyLoaded
        },
        set: function (value) {
          this.$store.commit('setLoadingCourseDialog', value)
        }
      },
      licenseClientToken () {
        return this.$store.getters['braintree/getClientToken']
      },
      loadingCourseDialogMsg () {
        return this.$store.getters['getLoadingCourseDialogMsg']
      },
      examStatus () {
        return this.$store.getters['course/getExamStatus']
      },
      levelDetails () {
        return this.$store.getters['learn/getFolders']
      },
      groups: function () {
        return this.$store.getters['course/getGroups']
      },
      badgeScore: function () {
        return this.$store.getters['course/getBadgeScore']
      },
      group () {
        return this.$store.getters['course/getGroups'].find(group => group.groupId === this.groupId())
      },
      tagDeckId () {
        return this.group.decks[0].regId
      },
      examQuestionsLoader () {
        return this.$store.getters['exam/getExamQuestionsLoader']
      },
      newUserLoggedIn () {
        return this.$store.getters['getNewUserLoggedIn']
      },
      refreshHomePage: {
        get: function () {
          return this.$store.getters['getRefreshHomePage']
        },
        set: function (data) {
          this.$store.commit('setRefreshHomePage', data)
        }
      },
      levels: {
        get: function () {
          return this.$store.getters['course/getLevels']
        },
        set: function (levels) {
          this.$store.commit('course/setLevels', levels)
        }
      },
      currentStep: {
        get: function () {
          return this.$store.getters.getTourCurrentStep
        },
        set: function () {
          // setting db object
        }
      },
      dbObject: {
        get: function () {
          return this.$store.getters['course/getDbObject']
        },
        set: function () {
          // setting db object
        }
      },
      user () {
        return this.$store.getters['user/getUserDetails']
      },
      pageTitle: {
        get: function () {
          return this.$store.getters['getPageTitle']
        },
        set: function (title) {
          this.$store.commit('setPageTitle', title)
        }
      },
      levelGroupDetails () {
        let groupId = this.$route.params.groupId
        return this.groups.find(group => {
          return parseInt(group.groupId) === parseInt(groupId)
        })
      },
      transactionSuccessful: {
        get: function () {
          return this.$store.getters['braintree/getTransactionSuccessfulLicense']
        },
        set: function (status) {
          this.$store.commit('braintree/setTransactionSuccessfulLicense', status)
        }
      },
      imageData: {
        get: function () {
          return this.$store.getters['user/avatar']
        },
        set: function (newValue) {
          this.$store.commit('user/setAvatar', newValue)
        }
      }
    },

    created () {
      // this.$store.commit('course/setExamStatus', 1)

      if (this.levelGroupDetails && Object.keys(this.levelGroupDetails).length > 0) {
        this.pageTitle = this.levelGroupDetails.groupName
      }
      if ((isEmpty(this.user) === false && this.levels.length === 0) || this.refreshHomePage === true) {
        this.initiateDashboard()
      }
      this.$store.dispatch('learn/fetchAllLevelsWithViews', { deckId: this.deckId(), level: 'all' })
      if (this.badgeScore > 0) {
        this.disableTour()
      }
      if (process.env.BADGE_IMAGES) {
        this.getBadgeImages()
      }
      this.couponByTag()
    },
    mounted: function () {
      if (this.examStatus === IN_EXAM) {
        this.isOverlay = true
        this.$tours['examTour'].start()
      }

      setTimeout(() => {
        this.getAvailableCoupons()
        this.goToTop()
      }, 100)
    },
    destroyed () {
      this.$store.commit('course/setCourseLevelLoadedAfterLogin', true)
    },
    methods: {
      ...mapMutations('registration', [
        'setUser', 'resetUser'
      ]),
      clearCoupon () {
        this.selectedCouponId = 0
        this.selectedCouponCode = ''
        this.appliedCoupon = ''
        this.effectivePrice = this.price
      },

      couponByTag () {
        this.$http({
          url: this.apiUrl + `/ws/userservice/coupons/course/${process.env.GAME_ID}?tags=ALL`,
          method: 'GET'
        }).then(res => {
          this.bestCoupon = res.data
        }).catch((e) => {
          console.log('Caught', e)
        })
      },
      validateCoupon () {
        const appliedCoupon = this.appliedCoupon
        if (!appliedCoupon) {
          this.$store.commit('flashError', 'Invalid coupon.', { root: true })
          return false
        }
        this.couponLoading = true
        this.$http({
          url: this.apiUrl + `/ws/checkout/coupon/${appliedCoupon}/user/${this.user.id}/course/${process.env.GAME_ID}`,
          method: 'GET',
          headers: {
            Authorization: 'Bearer ' + this.$auth.token()
          }
        }).then(res => {
          this.selectedCouponId = res.data.couponId
          this.selectedCouponCode = res.data.code
          this.effectivePrice = this.getDiscountedPrice(res.data.discount)
          this.couponLoading = false
        }, () => {
          this.$store.commit('flashError', 'Invalid coupon.', { root: true })
          this.couponLoading = false
        }).catch((e) => {
          console.log('Caught', e)
        })
      },
      onCancel () {
      },
      fetchBtToken () {
        this.$store.dispatch('braintree/purchaseLicense', this.user.id)
      },
      displayBadgeDialog () {
        this.displayBadgeDialogValue = new Date().getTime()
      },
      disableTour () {
        this.$store.commit('setTourStatus', false)
        this.$store.commit('setLearnStatus', false)
        this.$store.commit('setQuizStatus', false)
      },

      getBadgeButtonClass () {
        return {
          'exam-disabled no-pointer': this.badgeScore <= 0
        }
      },
      getExamButtonClass () {
        return {
          'current-step': this.currentStep === 5 || this.currentStep === 6 || this.isOverlay === true,
          'exam-disabled': this.examStatus === RETAKE || this.examStatus === NOT_READY
        }
      },
      disableExamPopup () {
        this.isOverlay = false
        this.$tours['examTour'].stop()
      },
      getBadgeImages () {
        if (this.badgeScore > 0) {
          this.$store.dispatch('exam/fetchCertificateImage', {
            deckId: this.group.decks[0].regId,
            userId: this.user.id
          }).then(data => {
            let prefix = 'data:' + data.headers['content-type'] + ';base64,'
            let img = Buffer.from(data.data, 'binary').toString('base64')
            this.certificateImg = prefix + img
          })
        }
        this.$store.dispatch('exam/fetchBadgeFrontImageNew', { deckId: this.group.decks[0].regId, userId: this.user.id }).then(data => {
          let prefix = 'data:' + data.headers['content-type'] + ';base64,'
          let img = Buffer.from(data.data, 'binary').toString('base64')
          this.frontImg = prefix + img
        }).catch(err => {
          console.error('fetchBadgeFrontImageNew', err)
        })
        this.$store.dispatch('exam/fetchBadgeBackImageNew', { deckId: this.group.decks[0].regId, userId: this.user.id }).then(data => {
          let prefix = 'data:' + data.headers['content-type'] + ';base64,'
          let img = Buffer.from(data.data, 'binary').toString('base64')
          this.backImg = prefix + img
        }).catch(err => {
          console.error('fetchBadgeBackImageNew', err)
        })
      },
      startExam () {
        this.$router.push({ name: 'Exam', params: { deckId: this.deckId(), groupId: this.groupId(), step: 1 } })
      },
      confirmExam () {
        this.badgeConfirm = true
        this.newExamDialogStep1 = true
        this.$store.dispatch('exam/fetchExamScore', {
          scheduleId: this.group.scheduleId,
          memberId: this.group.memberId
        })
      },
      getEnabledLevelsCount () {
        let enabledLevelsCount = 0
        this.levels.forEach((level, enabled) => {
          if (Object.keys(level.memberLevel).length !== 0) {
            enabledLevelsCount = enabledLevelsCount + 1
          }
        })
        return enabledLevelsCount
      },
      getExam () {
        this.buyNow = false
        if (this.currentStep === -1 && this.getEnabledLevelsCount() >= 4) {
          this.$store.commit('exam/setExamQuestionsLoader', false)
          if (this.examStatus === RETAKE || this.examStatus === NOT_READY) {
            this.isOverlay = true
            this.$tours['examTour'].start()
          } else if (this.examStatus === READY) {
            this.examDialog = true
          } else if (this.examStatus === IN_EXAM) {
            this.inExamDialog = true
            this.$store.dispatch('exam/fetchExamScore', {
              scheduleId: this.group.scheduleId,
              memberId: this.group.memberId
            })
          }
        } else {
          this.getCoursePrice()
        }
      },
      levelClassObj (index, level) {
        const lastPlayedLevel = this.$store.getters['course/getLastPlayedLevel']
        return {
          'current-step': this.currentStep === 0 && index === this.levels.length - 1,
          // 'level-details': Object.keys(level.memberLevel).length !== 0,
          'level-details': true,
          'px-2': this.$vuetify.breakpoint.name === 'xs' && parseInt(level.id) !== lastPlayedLevel,
          'px-3': this.$vuetify.breakpoint.name !== 'xs' && parseInt(level.id) !== lastPlayedLevel
        }
      },
      learnLevel (levelObj) {
        if (this.syncing === true) {
          this.$store.commit('flashInfo', 'Please wait while fetching course details.', { root: true })
          return
        }

        const level = levelObj.id
        if (Object.keys(levelObj.memberLevel).length !== 0 && this.currentStep === -1) {
          this.$loading.show({
            // container: this.fullPage ? null : this.$refs.formContainer1,
            container: this.$refs.formContainer1[0],
            canCancel: false,
            onCancel: this.onCancel
          })
          this.$store.commit('course/setLastPlayedLevel', level)
          setTimeout(() => {
            const deckId = this.deckId()
            const currentLevel = this.levelDetails.find(levelObj => levelObj.level_number === level)
            const viewCount = currentLevel.cards[0].views[0].viewCount
            const params = this.$store.getters['learn/getLastLearnRoute'][level]
            if (typeof params.level !== 'undefined' &&
              typeof params.deckId !== 'undefined' &&
              typeof params.viewCount !== 'undefined' &&
              typeof params.groupId !== 'undefined') {
              this.$router.push({ name: 'Learn', params })
            } else {
              this.$router.push({ name: 'Learn', params: { level, deckId, viewCount, groupId: this.groupId() } })
            }
          }, 200)
        } else {
          this.getCoursePrice()
        }
      },
      quizLevel (levelObj) {
        if (this.syncing === true) {
          this.$store.commit('flashInfo', 'Please wait while fetching course details.', { root: true })
          return
        }
        const level = levelObj.id
        if (Object.keys(levelObj.memberLevel).length !== 0 && this.currentStep === -1) {
          this.$store.commit('course/setLastPlayedLevel', level)
          const deckId = this.deckId()
          this.$router.push({ name: 'Quiz', params: { level, deckId, groupId: this.groupId(), step: 1 } })
        }
      },
      groupId () {
        return typeof this.$route.params.groupId !== 'undefined'
          ? parseInt(this.$route.params.groupId) : parseInt(this.groups[0].groupId)
      },
      deckId () {
        return typeof this.$route.params.deckId !== 'undefined'
          ? parseInt(this.$route.params.deckId) : parseInt(this.groups[0].decks[0].id)
      },

      latestQuizTime () {
        let seconds = parseInt(this.currentMemberLevel.latestQuizTime, 10)
        if (seconds > 60) {
          let days = Math.floor(seconds / (3600 * 24))
          seconds -= days * 3600 * 24
          let hrs = Math.floor(seconds / 3600)
          seconds -= hrs * 3600
          let mnts = Math.floor(seconds / 60)
          seconds -= mnts * 60
          let arr = []
          if (days !== 0) {
            arr.push(plural(days, 'day'))
          }
          if (hrs !== 0) {
            arr.push(plural(hrs, 'hr'))
          }
          if (mnts !== 0) {
            arr.push(plural(mnts, 'min'))
          }
          return arr.join(', ')
        } else if (seconds < 60 && seconds > 0) {
          return 'less then 1 min'
        } else {
          return '0 min and 0 sec'
        }
      },
      showLevelDetails (level) {
        if (this.syncing === true) {
          this.$store.commit('flashInfo', 'Please wait while fetching course details.', { root: true })
          return
        }
        if (this.currentStep === -1) {
          this.currentLevel = level
          this.currentMemberLevel = level.memberLevel
          this.progressDialog = true
        }
      },
      initiateDashboard () {
        const groupId = typeof this.$route.params.groupId !== 'undefined'
          ? this.$route.params.groupId : null
        const deckId = typeof this.$route.params.deckId !== 'undefined'
          ? this.$route.params.deckId : null
        if (deckId !== null) {
          const memberId = this.levelGroupDetails.memberId
          this.$store.dispatch('course/fetchMemberLevels', { groupId, deckId, memberId })
        }
      },
      getLearningNeedColor (level) {
        let color = 'grey'
        switch (level.memberLevel.learningNeedColor) {
          case 0: color = 'primary'
            break
          case 1: color = 'green'
            break
          case 2: color = 'yellow'
            break
          case 3: color = 'red'
            break
          default: color = 'grey'
        }
        const lastPlayedLevel = this.$store.getters['course/getLastPlayedLevel']
        const isDisabled = this.examStatus === IN_EXAM ? 'learn-disabled' : ''
        color += ' ' + isDisabled
        return parseInt(level.id) === lastPlayedLevel ? color + ' elevation-10 border-2' : color
      },
      getProgressIcon (level) {
        if (level.memberLevel.learningNeedColor === 3) {
          return false
        }
        const percentage = level.memberLevel.skillPercentage
        if (percentage <= 70 && percentage > 0) {
          return ['fas', 'check'] // skillStatus->beginner
        } else if (percentage > 70 && percentage <= 90) {
          return ['far', 'thumbs-up'] // skillStatus->advanced
        } else if (percentage > 90) {
          return ['fas', 'user-graduate'] // skillStatus->expert
        } else {
          return ['fas', 'book-reader'] // skillStatus->notStarted
        }
      },
      getQuizIcon (level) {
        const latestQuizTime = level.memberLevel.latestQuizTime
        if (latestQuizTime <= 3 * 30 && latestQuizTime > 0) {
          return { type: 'image', src: 'static/images/cat.png' }
        } else if (latestQuizTime > 3 * 30 && latestQuizTime <= 6 * 30) {
          return { type: 'image', src: 'static/images/bunny.png' }
        } else if (latestQuizTime > 6 * 30) {
          return { type: 'image', src: 'static/images/snail.png' }
        } else {
          return { type: 'icon', src: ['fas', 'question'] }
        }
      },
      openBuyNow () {
        this.buyNow = true
        this.getCoursePrice()
      },
      getCoursePrice () {
        this.$http({
          url: this.apiUrl + `/ws/playerservice/program/${this.appId}/cost`,
          method: 'GET',
          headers: {
            Authorization: 'Bearer ' + this.$auth.token()
          }
        }).then((res) => {
          this.clearCoupon()
          this.price = res.data.cost
          this.effectivePrice = res.data.cost
          if (this.buyNow) {
            this.selectCoupon(this.bestCoupon)
          }
          this.openUpgradeDialog()
        }, (err) => {
          console.log('error found', err)
        }).catch((e) => {
          console.log('Caught', e)
        })
      },
      selectCoupon (coupon) {
        this.appliedCoupon = coupon.code
        this.selectedCouponId = coupon.couponId
        this.selectedCouponCode = coupon.code
        this.showCoupons = false
        this.effectivePrice = this.getDiscountedPrice(coupon.discount)
      },
      getAvailableCoupons () {
        this.$http({
          url: this.apiUrl + `/ws/checkout/coupons/user/${this.user.id}/course/${process.env.GAME_ID}`,
          method: 'GET',
          headers: {
            Authorization: 'Bearer ' + this.$auth.token()
          }
        }).then((res) => {
          this.coupons = res.data
        }, (err) => {
          console.log('error found', err)
        }).catch((e) => {
          console.log('Caught', e)
        })
      },
      calculateDiscountedPrice (price, discount) {
        return parseFloat((price - ((price * discount) / 100)))
      },
      getDiscountedPrice (discount) {
        return parseFloat((this.price - ((this.price * discount) / 100)))
      },
      printPrice (price) {
        return Number.isInteger(price) ? price : price.toFixed(2)
      },
      openUpgradeDialog () {
        this.upgradeDialog = true
        this.showCoupons = false
      },
      goToTop () {
        const element = document.getElementById('app')
        element.scrollIntoView()
        document.body.scrollTop = 0 // For Safari
        document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
      }
    },
    watch: {
      // syncing (newVal) {
      //   if (newVal === false && this.$route.query.tour === 'start') {
      //     this.$store.commit('setDashboardTourStart', new Date().getTime())
      //   }
      // },
      transactionSuccessful (newVal) {
        if (newVal === true) {
          this.upgradeDialog = false
          this.initiateDashboard()
          this.$store.dispatch('learn/fetchAllLevelsWithViews', { deckId: this.deckId(), level: 'all' })
        }
      },
      dbObject (newVal) {
        this.isDbLoaded = true
      },
      user (newVal) {
        if (isEmpty(this.user) === false) {
          this.initiateDashboard()
          if (this.badgeScore > 0) {
            this.getBadgeImages()
          }
        }
      },
      settingsDrawer (newVal) {
        this.frontImg = ''
        this.backImg = ''
        if (this.badgeScore > 0) {
          this.getBadgeImages()
        }
        if (newVal === false) {
          this.getBadgeImages()
        }
      },
      examDialog (newVal) {
        setTimeout(() => {
          this.badgeConfirm = false
          this.badgeImage = 'front'
        }, 500)
      },
      badgeScore (newVal) {
        // console.log('badgeScore changed')
        if (this.newVal > 0) {
          this.getBadgeImages()
          this.disableTour()
        }
      },
      examStatus (newVal) {
        if (newVal === IN_EXAM) {
          this.isOverlay = true
          this.$tours['examTour'].start()
        }
      },
      levelGroupDetails (newVal) {
        this.pageTitle = newVal.groupName
      }
    }
  }
</script>

  <style lang="stylus">
    .invisible
      visibility: hidden
    .d-block
      display: block
    .d-none
      display: none
    .flex-border.green
      border: 1px solid #4CAF50 !important;
      border-radius: 5px!important;
    .green.lighten-4
      border-color: #4CAF50 !important;
    .flex-border.primary
      border: 1px solid #2196F3!important;
      border-radius: 5px!important;
    .primary.lighten-4
      border-color: #2196F3 !important;

    .flex-border.yellow
      border: 1px solid #FFEB3B!important;
      border-radius: 5px!important;
    .yellow.lighten-4
      border-color: #FFEB3B !important;
    .flex-border.red
      border: 1px solid #F44336!important;
      border-radius: 5px!important;
    .red.lighten-4
      border-color: #F44336 !important;
    .flex-border.grey
      border: 1px solid #9E9E9E!important;
      border-radius: 5px!important;
    .grey.lighten-4
      border-color: #9E9E9E !important;
    .level-details
      cursor: pointer;
    .blockquote
      font-weight: 400;

    .level-name{
      text-shadow: 1px 1px 1px rgba(154, 154, 154, 0.64)
      font-weight 400
    }
    div[data-popover="foo"] {
      left: 0!important;
      border: 1px solid #c20029;
      background-color: #FCC3CD;
      color: #910025;
      text-align: center;
      font-weight: 500;
    }
    .learn-disabled {
      pointer-events: none;
      opacity: 0.5;
      background: #CCC;
    }
    .no-pointer {
      pointer-events: none;
    }
    .exam-disabled {
      opacity: 0.5;
      background: #CCC;
    }

    .front {
      display: flex;
      align-items: center;
      justify-content: center;
      /*background-color: #673AB7;*/
      color: white;
    }

    .back {
      display: flex;
      align-items: center;
      justify-content: center;
      /*background-color: #FFC107;*/
      color: white
    }
    .shipping-stepper-header {
      /*padding-top: 10px;*/
      /*padding-bottom: 10px;*/
    }

    .table th {
      text-align: left;
    }
    .coupon {
      border: 2px dashed grey;
      padding: 5px 10px;
      text-align: center;
    }
    .coupon-hover:hover{
      cursor: pointer;
      border-style: solid;
    }
    .coupon-available {
      background-color: #e8f1fc;
      width: 100%;
      margin: 10px auto 0;
      border: 1px solid rgba(25,115,231,.25);
      padding: 5px 10px;
      color: #1973e7;
      text-decoration: underline;
      font-size: 14px;
      position: relative;
      cursor: pointer;
    }
    .coupon-available::before {
      content: "";
      display: inline-block;
      width: 12px;
      height: 12px;
      -moz-border-radius: 7.5px;
      -webkit-border-radius: 7.5px;
      border-radius: 7.5px;
      background-color: #f7f7f7;
      position: absolute;
      left: -5px;
      top: 32%;
      box-shadow: 1px 0 1px rgb(25 115 231 / 50%);
    }
    .coupon-available::after {
      content: "";
      display: inline-block;
      width: 12px;
      height: 12px;
      -moz-border-radius: 7.5px;
      -webkit-border-radius: 7.5px;
      border-radius: 7.5px;
      background-color: #f7f7f7;
      position: absolute;
      right: -5px;
      top: 32%;
      box-shadow: -1px 0 1px rgb(25 115 231 / 50%);
    }
    .v-input__append-inner {
      margin-top: 15px;
    }
</style>



// WEBPACK FOOTER //
// src/components/views/ProgramLevels.vue